/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumer_Declaration_Type_ExtraordinaryInputs */

const en_consumer_declaration_type_extraordinary = /** @type {(inputs: Consumer_Declaration_Type_ExtraordinaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extraordinary termination`)
};

const de_consumer_declaration_type_extraordinary = /** @type {(inputs: Consumer_Declaration_Type_ExtraordinaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Außerordentliche Kündigung`)
};

const fr_consumer_declaration_type_extraordinary = /** @type {(inputs: Consumer_Declaration_Type_ExtraordinaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Résiliation extraordinaire`)
};

const es_consumer_declaration_type_extraordinary = /** @type {(inputs: Consumer_Declaration_Type_ExtraordinaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminación extraordinaria`)
};

const it_consumer_declaration_type_extraordinary = /** @type {(inputs: Consumer_Declaration_Type_ExtraordinaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risoluzione straordinaria`)
};

const nl_consumer_declaration_type_extraordinary = /** @type {(inputs: Consumer_Declaration_Type_ExtraordinaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buitengewone opzegging`)
};

const pl_consumer_declaration_type_extraordinary = /** @type {(inputs: Consumer_Declaration_Type_ExtraordinaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wypowiedzenie nadzwyczajne`)
};

const fi_consumer_declaration_type_extraordinary = /** @type {(inputs: Consumer_Declaration_Type_ExtraordinaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poikkeuksellinen irtisanominen`)
};

const da_consumer_declaration_type_extraordinary = /** @type {(inputs: Consumer_Declaration_Type_ExtraordinaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ekstraordinær opsigelse`)
};

const sv_consumer_declaration_type_extraordinary = /** @type {(inputs: Consumer_Declaration_Type_ExtraordinaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extraordinär uppsägning`)
};

/**
* | output |
* | --- |
* | "Extraordinary termination" |
*
* @param {Consumer_Declaration_Type_ExtraordinaryInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consumer_declaration_type_extraordinary = /** @type {((inputs?: Consumer_Declaration_Type_ExtraordinaryInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumer_Declaration_Type_ExtraordinaryInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consumer_declaration_type_extraordinary(inputs)
	if (locale === "fr") return fr_consumer_declaration_type_extraordinary(inputs)
	if (locale === "es") return es_consumer_declaration_type_extraordinary(inputs)
	if (locale === "it") return it_consumer_declaration_type_extraordinary(inputs)
	if (locale === "nl") return nl_consumer_declaration_type_extraordinary(inputs)
	if (locale === "pl") return pl_consumer_declaration_type_extraordinary(inputs)
	if (locale === "fi") return fi_consumer_declaration_type_extraordinary(inputs)
	if (locale === "da") return da_consumer_declaration_type_extraordinary(inputs)
	if (locale === "sv") return sv_consumer_declaration_type_extraordinary(inputs)
	return en_consumer_declaration_type_extraordinary(inputs)
});